// extracted by mini-css-extract-plugin
export var addressCard = "AddressSuggestionModal-module__addressCard___RYvfD";
export var addressCardDark = "AddressSuggestionModal-module__addressCardDark___gZ+QY";
export var addressCardSelected = "AddressSuggestionModal-module__addressCardSelected___TmfOk";
export var addressCardSelectedDark = "AddressSuggestionModal-module__addressCardSelectedDark___SXQiG";
export var addressDetails = "AddressSuggestionModal-module__addressDetails___+09RX";
export var addressLine = "AddressSuggestionModal-module__addressLine___UOLCX";
export var addressLineDark = "AddressSuggestionModal-module__addressLineDark___mWXF0";
export var body = "AddressSuggestionModal-module__body___wWFjK";
export var bodyDark = "AddressSuggestionModal-module__bodyDark___TI8gl";
export var buttonRow = "AddressSuggestionModal-module__buttonRow___wEa1g";
export var cancelButton = "AddressSuggestionModal-module__cancelButton___k1eaJ";
export var cancelButtonDark = "AddressSuggestionModal-module__cancelButtonDark___wAwfD";
export var cardsContainer = "AddressSuggestionModal-module__cardsContainer___Lo9CZ";
export var confirmButton = "AddressSuggestionModal-module__confirmButton___A8Hq6";
export var confirmButtonDark = "AddressSuggestionModal-module__confirmButtonDark___9bOfo";
export var dialog = "AddressSuggestionModal-module__dialog___M52bq";
export var modalBody = "AddressSuggestionModal-module__modalBody___S5dre";
export var modalBodyDark = "AddressSuggestionModal-module__modalBodyDark___vNaBJ";
export var originalLabel = "AddressSuggestionModal-module__originalLabel___25a0J";
export var originalLabelDark = "AddressSuggestionModal-module__originalLabelDark___vyH4N";
export var partnerAccentGreen = "#228648";
export var partnerAccentGreenDisabled = "rgba(34, 134, 72, 0.4)";
export var partnerAccentGreenPressed = "rgba(34, 134, 72, 0.6)";
export var partnerLinkGlyphRest = "#71BB88";
export var radioInput = "AddressSuggestionModal-module__radioInput___MKT3q";
export var title = "AddressSuggestionModal-module__title___I07cK";
export var titleDark = "AddressSuggestionModal-module__titleDark___pFYWV";
export var unverifiedBadge = "AddressSuggestionModal-module__unverifiedBadge___9BkaQ";
export var verifiedBadge = "AddressSuggestionModal-module__verifiedBadge___-Z4YC";